import "../assets/styles/components/notification-card.scss";
import Dot from "../assets/icons/dot";

export default function NotificationCard({
  notification_info,
  setSelected = null,
}) {
  if (notification_info) {
    return (
      <div
        onClick={() => (setSelected ? setSelected(notification_info) : null)}
        className="notification-card w-100 mx-md-auto px-3 border-bottom position-relative py-2"
      >
        <small className="notification-date d-block text-end mb-1">
          {notification_info.plannedPublishDate
            ? new Date(
                notification_info.plannedPublishDate
              ).toLocaleDateString()
            : null}
        </small>
        <div className="d-flex align-items-center w-100">
          <div className="d-flex flex-wrap align-items-center w-100">
            <strong className="card-name d-block w-100 mb-1">
              {notification_info.title}
            </strong>
            <span className="extra-info d-flex align-items-center">
              {notification_info.text}
            </span>
          </div>
          {notification_info.read ? (
            <Dot size={13} color="#ffffff" className="ms-3 mb-4" />
          ) : (
            <Dot size={13} color="#f7323f" className="ms-3 mb-4" />
          )}
        </div>
      </div>
    );
  }
}
